import { recordCreatedAccount, useRegistrationAttempt } from '../features/product-segment'
import { acceptAuthenticatedDraft } from '../features/onboarding'
// Приём возврата из Яндекс-OAuth. Общий для двух путей:
//   web    — параметры приходят в query при загрузке страницы;
//   native — их приносит appUrlOpen из ссылки com.humanteq.app://oauth/yandex.
//
// Вынесено из main.tsx: там это было заперто в точке входа и не поддавалось
// тестам, а логика нетривиальная — проверка state против CSRF и три разных
// причины отказа.
import { useAuthStore } from '../store/authStore'
import { toast } from '../store/toastStore'
import { authApi } from '../api/auth'
import { getYandexClientId } from './ymUid'
import { reachGoal, setUserId } from './metrica'

export function applyOAuthParams(params: URLSearchParams, { stripUrl = true } = {}) {
  const strip = () => {
    if (!stripUrl) return
    const url = new URL(window.location.href)
    for (const key of ['auth_token', 'user_id', 'display_name', 'provider', 'state', 'created_user_id', 'login']) url.searchParams.delete(key)
    window.history.replaceState(null, '', url.pathname + url.search + url.hash)
  }

  if (params.get('login') === 'yandex_error') {
    toast('Не удалось войти через Яндекс. Попробуйте ещё раз.', 'error')
    strip()
    return
  }

  const token = params.get('auth_token')
  if (!token) return

  const urlState = params.get('state')
  const savedState = sessionStorage.getItem('yandex_oauth_state')
  sessionStorage.removeItem('yandex_oauth_state')
  // Защита от CSRF: если state выдавался, колбэк обязан вернуть такой же.
  // Пустой urlState тоже отвергаем — иначе подделанный редирект мог бы просто
  // не присылать параметр.
  if (savedState && savedState !== urlState) {
    toast('Ошибка входа через Яндекс. Попробуйте ещё раз.', 'error')
    strip()
    return
  }

  const userId = params.get('user_id')!
  const attempt = useRegistrationAttempt.getState().attempt
  if (attempt && urlState?.includes(`seg1:${attempt.id}:`)) recordCreatedAccount(attempt.id, params.get('created_user_id'))
  acceptAuthenticatedDraft(userId)
  useAuthStore.getState().setSession({
    accessToken: token,
    userId,
    displayName: params.get('display_name') || 'User',
  })
  if (params.get('provider') === 'yandex') {
    reachGoal('social_login', { provider: 'yandex' })
    setUserId(userId)
  }
  // ClientID Яндекс.Метрики для Центра конверсий Директа (bd-glg): в
  // OAuth-редиректе его передать негде, поэтому дослать после установки сессии.
  const ymUid = getYandexClientId()
  if (ymUid) {
    authApi.persistYandexClientId(ymUid).catch(() => {/* best-effort */})
  }
  strip()
}
